import { Injectable } from '@angular/core';

import {Store} from "@ngrx/store";
import {AppState} from "../models/app.state";
import {Router} from "@angular/router";
import { HttpService } from '../service/http.service';
import { RETRIVE_DETAILS } from '../actions/building.actions';

@Injectable()
export class UpgradeService {

  constructor( private httpService: HttpService,  
              private store: Store<AppState>,
              private router: Router,) { }

  userSetup(id){

    this.httpService.isManagerByUserId(id).subscribe(
      (res)=>{
        console.log(res, "manager status for the building========response")

        let building = res.building[0];

        this.store.dispatch({type: RETRIVE_DETAILS, payload: {address : building }});

        this.store.select('buildDetails').subscribe((data:any) => {
          res.user.accountUpgrade = true;
          data[0].address.teamMembers = [res.user];
          data[0].userData = res.user;
          data[0].newbuilding = false;
          data[0].upgrade = true;
          data[0].image = {building : null, profile: null};

         });
        this.router.navigate(['/managerprofile', 'managerbuildingprice']);

      },
      (error)=>{
        console.log(error, "manager status for the building========error")
      }
    );

  }

}
